import { IconButton, Text } from "../UI";
import { format } from "date-fns";
import { he } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import removeImg from "../asserts/img/x_black.svg";

const DateFilter = ({ date, setDate }) => {
  const { t } = useTranslation("common");

  return (
    <>
      {!!date?.[1] && !!date?.[0] && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            padding: 20,
            justifyContent: "space-between",
            borderBottom: ` 1px solid #DADADA`,
          }}>
          <div
            style={{
              flexBasis: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 5,
            }}>
            <Text style={{ fontSize: 15, fontWeight: 600 }}>
              {format(new Date(date[0]), "LLL d  yyyy", { locale: he })}
            </Text>
            <Text style={{ fontSize: 14, fontWeight: 400, color: "#B1B1B1" }}>
              {t("common:start_date")}
            </Text>
          </div>
          <div
            style={{
              flexBasis: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 5,
            }}>
            <Text style={{ fontSize: 15, fontWeight: 600 }}>
              {format(new Date(date[1]), "LLL d  yyyy", { locale: he })}
            </Text>
            <Text style={{ fontSize: 14, fontWeight: 400, color: "#B1B1B1" }}>
              {t("common:end_date")}
            </Text>
          </div>
          <IconButton
            src={removeImg}
            iconSize={12}
            label={t("common:clear_dates")}
            style={{ marginInlineStart: "auto" }}
            onClick={() => setDate(null)}
          />
        </div>
      )}
    </>
  );
};

export default DateFilter;
